module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-14.dbb180db.JPG";